// A module containing utilities used for filtering logic.

/**
 * Return whether the given whole string instance contains an instance
 * of the search term within it, ignoring any differences in case.
 * @param {string} wholeString The whole string to search within
 * @param {string} instance A string instance used as the search term.
 * @returns {boolean} Whether the instance appears in the whole string.
 */
export function containsInvariant(wholeString, instance) {
    return !instance || (wholeString || "").toLowerCase().indexOf((instance || "").toLowerCase()) > -1;
}

/**
 * Return whether the two strings are equal, ignoring any differences in case.
 * @param {string} wholeString The left string instance
 * @param {string} instance The right string instance
 * @returns {boolean} Whether the strings are equal.
 */
export function equalsInvariant(wholeString, instance) {
    return (wholeString || "").toLowerCase() === (instance || "").toLowerCase();
}

/**
 * Return whether the given object contains an instance of all strings given
 * in the filter object, specified by the list of specific fields.
 * @param {any} obj The object being compared.
 * @param {any} filters An object representing filters on the given object.
 * @param {string[]} fields The list of field names which must all match or be
 *   left blank in order for the filter to return true.
 * @returns {boolean} Whether the object contains all fields in the filter object.
 */
export function allContainsInvariant(obj, filters, fields) {
    return allFilter(obj, filters, fields, containsInvariant);
}

export function allFilter(obj, filters, fields, comparer) {
    return fields.reduce((all, field) => all &&
        // If the filtered value is falsy, do not perform the filter.
        (!filters[field] || comparer(obj[field], filters[field])), true);
}

